import { render, staticRenderFns } from "./color-pick.vue?vue&type=template&id=819c324a&scoped=true"
import script from "./color-pick.vue?vue&type=script&lang=js"
export * from "./color-pick.vue?vue&type=script&lang=js"
import style0 from "./color-pick.vue?vue&type=style&index=0&id=819c324a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819c324a",
  null
  
)

export default component.exports